import { createContext } from 'react';

const InstanceIdContext = createContext<symbol | null>(null);

export { InstanceIdContext };
